import { Box, Paper } from '@mui/material'

const AuthLayout = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'background.default',
                pt: { xs: 4, sm: 6 }
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: 2,
                    maxWidth: '400px',
                    width: '100%',
                    mx: 2
                }}
            >
                {children}
            </Paper>
        </Box>
    )
}

export default AuthLayout 